import { render, staticRenderFns } from "./MobilePortraitNav.vue?vue&type=template&id=6c93a8a2"
import script from "./MobilePortraitNav.vue?vue&type=script&lang=js"
export * from "./MobilePortraitNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports